export default __webpack_public_path__ + "static/media/ai-icon.7d937e23.svg";